import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { staffAPI } from "@/lib/staff-api";
import { queryKeys } from "@/lib/query-keys";
import type { StaffDetail } from "@/lib/staff-api";

export const useStaffDetail = (id: string) => {
  return useQuery<StaffDetail>({
    queryKey: queryKeys.staff.detail(id),
    queryFn: () => staffAPI.fetchStaffDetail(id),
    enabled: !!id,
    retry: false,
  });
};

export const useUpdateStaff = () => {
  const queryClient = useQueryClient();

  return useMutation<
    { success: string },
    any,
    { id: string; formData: FormData }
  >({
    mutationFn: ({ id, formData }) => staffAPI.updateStaff(id, formData),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.staff.all });
      queryClient.invalidateQueries({
        queryKey: queryKeys.staff.detail(variables.id),
      });
    },
  });
};
